import React from 'react';
import PropTypes from 'prop-types';
import {  LuArrowLeft } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

// DS
import {
    VertButton,
  VertContainer, Col
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Header/HeaderStyles.less';
import Icon from "components/Atoms/Icons/Icon";

// HEADER DESKTOP COMPONENT
const HeaderCheckoutMobile = ({
  logo
}) => {
    const navigate = useNavigate();

  /* Renders */
  return (
    <VertContainer fluid className="header-desktop-container  header-desktop-checkout-container">
      <VertContainer className="vert-box-header" spacingX="regular">
        <div className="header-main-content">
          <div className="header-logo">
            <Link to={'/'} title="Ir para página inicial">
              <img src={logo} alt={`logotipo ${process.env.REACT_APP_TITLE}`} />
            </Link>
          </div>

            <div style={{ flex: 1 }} />
            <Col className="back-to-cart">
                <VertButton
                    type="link"
                    spacing="none"
                    onClick={() => navigate(`/cart`)}
                >
                  <Icon className="icon" size={"22px"} component={LuArrowLeft} aria-label={'Voltar para o carrinho'} />
                </VertButton>
            </Col>
                
        </div>
      </VertContainer>
    </VertContainer>
  );
};

HeaderCheckoutMobile.propTypes = {
  logo: PropTypes.string
};

export default HeaderCheckoutMobile;
